"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.AuthHttpClient = exports.AuthRpcServer = exports.AuthNoopEventPublisher = exports.AuthRpcEventPublisher = exports.AuthNoopService = exports.AuthRpcClient = exports.RoutingKeys = exports.RegisterResponse = exports.TokenDetails = exports.TokenData = exports.MissingEmailOrMerchantId = exports.InvalidPassword = exports.InvalidUsername = exports.UsernameAlreadyTaken = exports.UnsupportedAudience = exports.InvalidCredentials = exports.TokenExpired = exports.InvalidToken = exports.TokenDataType = exports.Audience = void 0;
var error_1 = require("../error");
var auth = require("../auth/index");
var Audience;
(function (Audience) {
    Audience["WebPublic"] = "WebPublic";
    Audience["Kiosk"] = "Kiosk";
    Audience["Ecom"] = "Ecom";
    Audience["Hub"] = "Hub";
    Audience["MerchantAdmin"] = "MerchantAdmin";
    Audience["P2PPlatformMachineUser"] = "P2PPlatformMachineUser";
    Audience["QA"] = "QA";
})(Audience = exports.Audience || (exports.Audience = {}));
;
;
;
;
;
;
;
;
var TokenDataType;
(function (TokenDataType) {
    TokenDataType["EcomConsumerEmail"] = "EcomConsumerEmail";
    TokenDataType["EcomConsumerOrder"] = "EcomConsumerOrder";
    TokenDataType["DroppaEmployee"] = "DroppaEmployee";
    TokenDataType["MerchantEmployee"] = "MerchantEmployee";
    TokenDataType["P2PPlatformMachineUser"] = "P2PPlatformMachineUser";
    TokenDataType["KioskEmployee"] = "KioskEmployee";
})(TokenDataType = exports.TokenDataType || (exports.TokenDataType = {}));
var utils_1 = require("../../utils");
(function (Audience) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Audience"), AudienceTypeMap);
    }
    Audience.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Audience"), AudienceTypeMap));
    }
    Audience.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Audience"), AudienceTypeMap);
    }
    Audience.fromValue = fromValue;
})(Audience = exports.Audience || (exports.Audience = {}));
var AudienceTypeMap = {
    "Audience": ["WebPublic", "Kiosk", "Ecom", "Hub", "MerchantAdmin", "P2PPlatformMachineUser", "QA"]
};
var InvalidToken;
(function (InvalidToken) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("InvalidToken"), InvalidTokenTypeMap);
    }
    InvalidToken.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("InvalidToken"), InvalidTokenTypeMap));
    }
    InvalidToken.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("InvalidToken"), InvalidTokenTypeMap);
    }
    InvalidToken.fromValue = fromValue;
})(InvalidToken = exports.InvalidToken || (exports.InvalidToken = {}));
var InvalidTokenTypeMap = {
    "InvalidToken": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var TokenExpired;
(function (TokenExpired) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("TokenExpired"), TokenExpiredTypeMap);
    }
    TokenExpired.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("TokenExpired"), TokenExpiredTypeMap));
    }
    TokenExpired.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("TokenExpired"), TokenExpiredTypeMap);
    }
    TokenExpired.fromValue = fromValue;
})(TokenExpired = exports.TokenExpired || (exports.TokenExpired = {}));
var TokenExpiredTypeMap = {
    "TokenExpired": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var InvalidCredentials;
(function (InvalidCredentials) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("InvalidCredentials"), InvalidCredentialsTypeMap);
    }
    InvalidCredentials.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("InvalidCredentials"), InvalidCredentialsTypeMap));
    }
    InvalidCredentials.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("InvalidCredentials"), InvalidCredentialsTypeMap);
    }
    InvalidCredentials.fromValue = fromValue;
})(InvalidCredentials = exports.InvalidCredentials || (exports.InvalidCredentials = {}));
var InvalidCredentialsTypeMap = {
    "InvalidCredentials": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var UnsupportedAudience;
(function (UnsupportedAudience) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("UnsupportedAudience"), UnsupportedAudienceTypeMap);
    }
    UnsupportedAudience.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("UnsupportedAudience"), UnsupportedAudienceTypeMap));
    }
    UnsupportedAudience.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("UnsupportedAudience"), UnsupportedAudienceTypeMap);
    }
    UnsupportedAudience.fromValue = fromValue;
})(UnsupportedAudience = exports.UnsupportedAudience || (exports.UnsupportedAudience = {}));
var UnsupportedAudienceTypeMap = {
    "UnsupportedAudience": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var UsernameAlreadyTaken;
(function (UsernameAlreadyTaken) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("UsernameAlreadyTaken"), UsernameAlreadyTakenTypeMap);
    }
    UsernameAlreadyTaken.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("UsernameAlreadyTaken"), UsernameAlreadyTakenTypeMap));
    }
    UsernameAlreadyTaken.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("UsernameAlreadyTaken"), UsernameAlreadyTakenTypeMap);
    }
    UsernameAlreadyTaken.fromValue = fromValue;
})(UsernameAlreadyTaken = exports.UsernameAlreadyTaken || (exports.UsernameAlreadyTaken = {}));
var UsernameAlreadyTakenTypeMap = {
    "UsernameAlreadyTaken": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var InvalidUsername;
(function (InvalidUsername) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("InvalidUsername"), InvalidUsernameTypeMap);
    }
    InvalidUsername.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("InvalidUsername"), InvalidUsernameTypeMap));
    }
    InvalidUsername.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("InvalidUsername"), InvalidUsernameTypeMap);
    }
    InvalidUsername.fromValue = fromValue;
})(InvalidUsername = exports.InvalidUsername || (exports.InvalidUsername = {}));
var InvalidUsernameTypeMap = {
    "InvalidUsername": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var InvalidPassword;
(function (InvalidPassword) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("InvalidPassword"), InvalidPasswordTypeMap);
    }
    InvalidPassword.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("InvalidPassword"), InvalidPasswordTypeMap));
    }
    InvalidPassword.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("InvalidPassword"), InvalidPasswordTypeMap);
    }
    InvalidPassword.fromValue = fromValue;
})(InvalidPassword = exports.InvalidPassword || (exports.InvalidPassword = {}));
var InvalidPasswordTypeMap = {
    "InvalidPassword": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var MissingEmailOrMerchantId;
(function (MissingEmailOrMerchantId) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("MissingEmailOrMerchantId"), MissingEmailOrMerchantIdTypeMap);
    }
    MissingEmailOrMerchantId.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("MissingEmailOrMerchantId"), MissingEmailOrMerchantIdTypeMap));
    }
    MissingEmailOrMerchantId.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("MissingEmailOrMerchantId"), MissingEmailOrMerchantIdTypeMap);
    }
    MissingEmailOrMerchantId.fromValue = fromValue;
})(MissingEmailOrMerchantId = exports.MissingEmailOrMerchantId || (exports.MissingEmailOrMerchantId = {}));
var MissingEmailOrMerchantIdTypeMap = {
    "MissingEmailOrMerchantId": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var TokenData;
(function (TokenData) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("TokenData"), TokenDataTypeMap);
    }
    TokenData.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("TokenData"), TokenDataTypeMap));
    }
    TokenData.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("TokenData"), TokenDataTypeMap);
    }
    TokenData.fromValue = fromValue;
})(TokenData = exports.TokenData || (exports.TokenData = {}));
var TokenDataTypeMap = {
    "TokenData": {
        unionMembers: [
            {
                props: [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                    { json: "type", js: "type", typ: ["EcomConsumerEmail"] }]
            }, {
                props: [{ json: "merchantId", js: "merchantId", typ: "string" },
                    { json: "emailAddress", js: "emailAddress", typ: "string" },
                    { json: "orderNumber", js: "orderNumber", typ: "string" },
                    { json: "type", js: "type", typ: ["EcomConsumerOrder"] }]
            }, {
                props: [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                    { json: "droppaEmployeeRoles", js: "droppaEmployeeRoles", typ: {
                            unionMembers: [
                                { arrayItems: "string" },
                                null,
                                undefined,
                                []
                            ]
                        } },
                    { json: "type", js: "type", typ: ["DroppaEmployee"] }]
            }, {
                props: [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                    { json: "merchantId", js: "merchantId", typ: "string" },
                    { json: "merchantEmployeeRoles", js: "merchantEmployeeRoles", typ: {
                            unionMembers: [
                                { arrayItems: "string" },
                                null,
                                undefined,
                                []
                            ]
                        } },
                    { json: "type", js: "type", typ: ["MerchantEmployee"] }]
            }, {
                props: [{ json: "p2pPlatform", js: "p2pPlatform", typ: "string" },
                    { json: "type", js: "type", typ: ["P2PPlatformMachineUser"] }]
            }, {
                props: [{ json: "type", js: "type", typ: ["KioskEmployee"] }]
            },
        ]
    }
};
var TokenDetails;
(function (TokenDetails) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("TokenDetails"), TokenDetailsTypeMap);
    }
    TokenDetails.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("TokenDetails"), TokenDetailsTypeMap));
    }
    TokenDetails.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("TokenDetails"), TokenDetailsTypeMap);
    }
    TokenDetails.fromValue = fromValue;
})(TokenDetails = exports.TokenDetails || (exports.TokenDetails = {}));
var TokenDetailsTypeMap = {
    "TokenDetails": (0, utils_1.o)([
        { json: "audience", js: "audience", typ: ["WebPublic", "Kiosk", "Ecom", "Hub", "MerchantAdmin", "P2PPlatformMachineUser", "QA"] },
        { json: "tokenData", js: "tokenData", typ: {
                unionMembers: [
                    {
                        props: [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                            { json: "type", js: "type", typ: ["EcomConsumerEmail"] }]
                    }, {
                        props: [{ json: "merchantId", js: "merchantId", typ: "string" },
                            { json: "emailAddress", js: "emailAddress", typ: "string" },
                            { json: "orderNumber", js: "orderNumber", typ: "string" },
                            { json: "type", js: "type", typ: ["EcomConsumerOrder"] }]
                    }, {
                        props: [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                            { json: "droppaEmployeeRoles", js: "droppaEmployeeRoles", typ: {
                                    unionMembers: [
                                        { arrayItems: "string" },
                                        null,
                                        undefined,
                                        []
                                    ]
                                } },
                            { json: "type", js: "type", typ: ["DroppaEmployee"] }]
                    }, {
                        props: [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                            { json: "merchantId", js: "merchantId", typ: "string" },
                            { json: "merchantEmployeeRoles", js: "merchantEmployeeRoles", typ: {
                                    unionMembers: [
                                        { arrayItems: "string" },
                                        null,
                                        undefined,
                                        []
                                    ]
                                } },
                            { json: "type", js: "type", typ: ["MerchantEmployee"] }]
                    }, {
                        props: [{ json: "p2pPlatform", js: "p2pPlatform", typ: "string" },
                            { json: "type", js: "type", typ: ["P2PPlatformMachineUser"] }]
                    }, {
                        props: [{ json: "type", js: "type", typ: ["KioskEmployee"] }]
                    },
                ]
            } }
    ], false)
};
var RegisterResponse;
(function (RegisterResponse) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("RegisterResponse"), RegisterResponseTypeMap);
    }
    RegisterResponse.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("RegisterResponse"), RegisterResponseTypeMap));
    }
    RegisterResponse.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("RegisterResponse"), RegisterResponseTypeMap);
    }
    RegisterResponse.fromValue = fromValue;
})(RegisterResponse = exports.RegisterResponse || (exports.RegisterResponse = {}));
var RegisterResponseTypeMap = {
    "RegisterResponse": (0, utils_1.o)([], false)
};
var RoutingKeys;
(function (RoutingKeys) {
    RoutingKeys["IssueToken"] = "com.droppa.auth.issueToken";
    RoutingKeys["DecodeToken"] = "com.droppa.auth.decodeToken";
    RoutingKeys["Register"] = "com.droppa.auth.register";
    RoutingKeys["LogIn"] = "com.droppa.auth.logIn";
})(RoutingKeys = exports.RoutingKeys || (exports.RoutingKeys = {}));
(function (RoutingKeys) {
    RoutingKeys.All = [RoutingKeys.IssueToken, RoutingKeys.DecodeToken, RoutingKeys.Register, RoutingKeys.LogIn];
    function from(value) {
        var routingKey = RoutingKeys.All.find(function (x) { return x.toString() === value; });
        if (routingKey != undefined) {
            return routingKey;
        }
        throw new Error("Unknown routing key: ".concat(value));
    }
    RoutingKeys.from = from;
})(RoutingKeys = exports.RoutingKeys || (exports.RoutingKeys = {}));
var AuthRpcClient = /** @class */ (function () {
    function AuthRpcClient(client) {
        this.client = client;
    }
    AuthRpcClient.prototype.issueToken = function (audience, tokenData) {
        var request = { audience: audience, tokenData: tokenData };
        return this.client.request(RoutingKeys.IssueToken, request);
    };
    AuthRpcClient.prototype.decodeToken = function (token) {
        var request = { token: token };
        return this.client.request(RoutingKeys.DecodeToken, request);
    };
    AuthRpcClient.prototype.register = function (audience, username, password, emailAddress, merchantId) {
        var request = { audience: audience, username: username, password: password, emailAddress: emailAddress, merchantId: merchantId };
        return this.client.request(RoutingKeys.Register, request);
    };
    AuthRpcClient.prototype.logIn = function (audience, username, password) {
        var request = { audience: audience, username: username, password: password };
        return this.client.request(RoutingKeys.LogIn, request);
    };
    return AuthRpcClient;
}());
exports.AuthRpcClient = AuthRpcClient;
var AuthNoopService = /** @class */ (function () {
    function AuthNoopService() {
    }
    /**
     * Issue a token for an audience without username/password authentication.
     */
    AuthNoopService.prototype.issueToken = function (audience, tokenData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("AuthNoopService.issueToken() not implemented");
            });
        });
    };
    /**
     * Check validity of token.
     */
    AuthNoopService.prototype.decodeToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("AuthNoopService.decodeToken() not implemented");
            });
        });
    };
    /**
     * Create new user for audience.
     * @param emailAddress  Only for MerchantAdmin audience
     * @param merchantId  Only for MerchantAdmin audience
     */
    AuthNoopService.prototype.register = function (audience, username, password, emailAddress, merchantId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("AuthNoopService.register() not implemented");
            });
        });
    };
    /**
     * Look up credentials for audience in database and if valid, issue a token.
     */
    AuthNoopService.prototype.logIn = function (audience, username, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("AuthNoopService.logIn() not implemented");
            });
        });
    };
    return AuthNoopService;
}());
exports.AuthNoopService = AuthNoopService;
var AuthRpcEventPublisher = /** @class */ (function () {
    function AuthRpcEventPublisher(client) {
        this.client = client;
    }
    return AuthRpcEventPublisher;
}());
exports.AuthRpcEventPublisher = AuthRpcEventPublisher;
var AuthNoopEventPublisher = /** @class */ (function () {
    function AuthNoopEventPublisher() {
    }
    return AuthNoopEventPublisher;
}());
exports.AuthNoopEventPublisher = AuthNoopEventPublisher;
var AuthRpcServer = /** @class */ (function () {
    function AuthRpcServer(service) {
        this.service = service;
        this.handlerMapCached = this.generateHandlerMap();
    }
    AuthRpcServer.prototype.handle = function (routingKey, body) {
        var method = this.handlerMapCached[routingKey];
        if (method == null) {
            throw new Error("Unknown routing key ".concat(routingKey));
        }
        return method(body);
    };
    AuthRpcServer.prototype.handlerMap = function () { return this.handlerMapCached; };
    AuthRpcServer.prototype.generateHandlerMap = function () {
        var _a;
        return _a = {},
            _a[RoutingKeys.IssueToken] = this.issueToken.bind(this),
            _a[RoutingKeys.DecodeToken] = this.decodeToken.bind(this),
            _a[RoutingKeys.Register] = this.register.bind(this),
            _a[RoutingKeys.LogIn] = this.logIn.bind(this),
            _a;
    };
    AuthRpcServer.prototype.routingKeys = function () {
        return [RoutingKeys.IssueToken.toString(), RoutingKeys.DecodeToken.toString(), RoutingKeys.Register.toString(), RoutingKeys.LogIn.toString()];
    };
    AuthRpcServer.prototype.issueToken = function (_a) {
        var audience = _a.audience, tokenData = _a.tokenData;
        return this.service.issueToken(audience, tokenData);
    };
    AuthRpcServer.prototype.decodeToken = function (_a) {
        var token = _a.token;
        return this.service.decodeToken(token);
    };
    AuthRpcServer.prototype.register = function (_a) {
        var audience = _a.audience, username = _a.username, password = _a.password, emailAddress = _a.emailAddress, merchantId = _a.merchantId;
        return this.service.register(audience, username, password, emailAddress, merchantId);
    };
    AuthRpcServer.prototype.logIn = function (_a) {
        var audience = _a.audience, username = _a.username, password = _a.password;
        return this.service.logIn(audience, username, password);
    };
    return AuthRpcServer;
}());
exports.AuthRpcServer = AuthRpcServer;
var AuthHttpClient = /** @class */ (function () {
    function AuthHttpClient(client) {
        this.client = client;
    }
    AuthHttpClient.prototype.issueToken = function (audience, tokenData) {
        var request = { audience: audience, tokenData: tokenData };
        return this.client.call("auth", "issueToken", request).then(function (result) {
            if (typeof result === "string") {
                return result;
            }
            else {
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
            }
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    AuthHttpClient.prototype.decodeToken = function (token) {
        var request = { token: token };
        return this.client.call("auth", "decodeToken", request).then(function (result) { return auth.TokenDetails.fromValue(result); }, function (e) {
            return e.response.json().then(function (e) {
                var err;
                if (e.error === 'InvalidToken') {
                    try {
                        err = auth.InvalidToken.fromValue(e);
                    }
                    catch (_a) { }
                }
                if (e.error === 'TokenExpired') {
                    try {
                        err = auth.TokenExpired.fromValue(e);
                    }
                    catch (_b) { }
                }
                if (err) {
                    throw err;
                }
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
            });
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    AuthHttpClient.prototype.register = function (audience, username, password, emailAddress, merchantId) {
        var request = { audience: audience, username: username, password: password, emailAddress: emailAddress, merchantId: merchantId };
        return this.client.call("auth", "register", request).then(function (result) { return RegisterResponse.fromValue(result); }, function (e) {
            return e.response.json().then(function (e) {
                var err;
                if (e.error === 'UsernameAlreadyTaken') {
                    try {
                        err = auth.UsernameAlreadyTaken.fromValue(e);
                    }
                    catch (_a) { }
                }
                if (e.error === 'InvalidUsername') {
                    try {
                        err = auth.InvalidUsername.fromValue(e);
                    }
                    catch (_b) { }
                }
                if (e.error === 'InvalidPassword') {
                    try {
                        err = auth.InvalidPassword.fromValue(e);
                    }
                    catch (_c) { }
                }
                if (e.error === 'MissingEmailOrMerchantId') {
                    try {
                        err = auth.MissingEmailOrMerchantId.fromValue(e);
                    }
                    catch (_d) { }
                }
                if (err) {
                    throw err;
                }
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
            });
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    AuthHttpClient.prototype.logIn = function (audience, username, password) {
        var request = { audience: audience, username: username, password: password };
        return this.client.call("auth", "logIn", request).then(function (result) {
            if (typeof result === "string") {
                return result;
            }
            else {
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
            }
        }, function (e) {
            return e.response.json().then(function (e) {
                var err;
                if (e.error === 'InvalidCredentials') {
                    try {
                        err = auth.InvalidCredentials.fromValue(e);
                    }
                    catch (_a) { }
                }
                if (e.error === 'UnsupportedAudience') {
                    try {
                        err = auth.UnsupportedAudience.fromValue(e);
                    }
                    catch (_b) { }
                }
                if (e.error === 'TokenExpired') {
                    try {
                        err = auth.TokenExpired.fromValue(e);
                    }
                    catch (_c) { }
                }
                if (err) {
                    throw err;
                }
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
            });
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    return AuthHttpClient;
}());
exports.AuthHttpClient = AuthHttpClient;
//# sourceMappingURL=index.js.map